export const hasToken = ({ token }) => !!token;
export const GetUser = ({ user }) => user;
export const getCliente = ({ user }) => user.cliente;
export const userIsAdmin = ({ user }) => {
  const roles = user.roles;
  if (!roles) return false;
  if (typeof roles === "object" && !Array.isArray(roles)) return false;

  const hasAdminRole = (role) => {
    const includesItem = (item) => ["super-admin", "admin"].includes(item);
    if (role.name) return includesItem(role.name);
    return includesItem(role);
  };
  const userIsSuperAdmin =
    roles.length > 0 && roles.findIndex(hasAdminRole) > -1;

  return userIsSuperAdmin;
};
export const GetUserRoles = ({ user }) => user.roles;
export const getUserPermissions = ({ user }) =>
  user.permissions || JSON.parse(localStorage["@app/permissions"] || "[]");
export const GetUrlClient = ({ user }) => {
  if (!user.cliente) {
    return "";
  }
  return user.cliente.url;
};
